import { isEmbarcacaoGuinchosGuindastesEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoGuinchoGuindaste,
  EmbarcacaoGuinchosGuindastesState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const GUINCHOS_GUINDASTES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoGuinchoGuindaste[]> = {
  select: (ficha) => ficha.guinchosGuindastes,
  isEmpty: isEmbarcacaoGuinchosGuindastesEmpty,
  secao: "os Guinchos e Guindastes",
};

interface UseEmbarcacaoGuinchosGuindastesResult extends EmbarcacaoGuinchosGuindastesState {
  reload: () => void;
}

/** Consulta os guinchos e guindastes da embarcação pedida. Somente leitura. */
export function useEmbarcacaoGuinchosGuindastes(id: string): UseEmbarcacaoGuinchosGuindastesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, GUINCHOS_GUINDASTES_QUERY);

  return { ...state, guinchosGuindastes: data };
}
